/**
 * Created by Ivan on 29.07.2026
 */

const FieldRewardView = cc.Node.extend({
    ctor: function (fieldReward, unitView) {
        this._super();

        this.fieldReward = fieldReward;
        this.unitView = unitView;

        this.setAnchorPoint(0.5, 0.5);

        const styles = cleverapps.styles.FieldRewardView;

        this.setContentSize2(unitView.getContentSize());

        const content = this.content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.setScale(cleverapps.resolution.isVertical() ? styles.verticalScale : styles.scale);
        this.addChild(content);

        const bubble = this.bubble = new cc.Sprite(bundles.merge.frames.field_reward_bubble_png);
        content.addChild(bubble);
        cleverapps.UI.wrap(content);
        content.setAlignment(styles.position);

        this.createRewards();

        if (this.fieldReward.getUnitsLibraryUnit()) {
            const attention = new cc.Sprite(bundles.merge.frames.field_reward_attention_png);
            attention.setScale(styles.attention.scale);
            attention.setAlignment(styles.attention.position);
            content.addChild(attention);
        }

        cleverapps.UI.onClick(bubble, () => {
            if (!this.fieldReward.isActive() || this.fieldReward.handleClick()) {
                return;
            }

            this.fieldReward.unit.squeeze();
            Merge2.current.showHint(this.unitView, Messages.get("FieldReward.clickMessage"));
        }, { interactiveScale: false });

        this.setCascadeOpacityEnabledRecursively(true);

        this.setVisible(this.fieldReward.isActive());
    },

    createRewards: function () {
        const styles = cleverapps.styles.FieldRewardView;

        const rewards = this.fieldReward.rewardsList.listRewards();

        if (rewards.length > 1) {
            const prize = new cleverapps.Spine(bundles.prize.jsons.prize_json);
            prize.setAnimation(0, "idle", true);
            cleverapps.UI.fitToBox(prize, styles.icon);
            prize.setAlignment(styles.icon.position);
            this.content.addChild(prize);
            return;
        }

        const reward = rewards[0];
        const withText = reward.type !== "units" && reward.getAmount() > 1;
        const isEnergy = reward.type === "energy";

        const icon = isEnergy
            ? new cc.Sprite(bundles.merge.frames.field_reward_energy_png)
            : reward.getSmallIcon();
        cleverapps.UI.fitToBox(icon, isEnergy ? styles.energyIcon : styles.icon);
        const position = withText ? styles.icon.withTextPosition : styles.icon.position;
        icon.setAlignment({
            x: position.x,
            y: { ...position.y, dy: (position.y.dy || 0) + (isEnergy ? styles.energyIcon.offset.y : 0) }
        });
        this.content.addChild(icon);

        if (withText) {
            const text = cleverapps.UI.generateOnlyText(reward.getText(), cleverapps.styles.FONTS.FIELD_REWARD_TEXT);
            text.setAlignment(styles.text.position);
            this.content.addChild(text);
        }
    },

    collect: function () {
        this.content.runAction(new cc.ScaleTo(0.2, 0).easing(cc.easeBackIn()));

        this.runAction(new cc.Sequence(
            new cc.Spawn(
                new cc.FadeOut(0.3),
                new cc.ScaleTo(0.3, 1.1)
            ),
            new cc.Hide()
        ));
    },

    showTooltip: function () {
        const tooltip = PrefabBuilder.instantiate(bundles.merge.jsons.field_reward_tooltip_prefab_json, {
            rewards: this.fieldReward.rewards
        });
        tooltip.show(this.bubble);
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    FIELD_REWARD_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: {
            color: new cc.Color(148, 86, 45, 255),
            size: 3
        }
    }
});

cleverapps.styles.FieldRewardView = {
    position: { x: { align: "center" }, y: { align: "center" } },
    scale: 1,
    verticalScale: 1,

    icon: {
        width: 100,
        height: 100,
        position: { x: { align: "center" }, y: { align: "center" } },
        withTextPosition: { x: { align: "center" }, y: { align: "center", dy: 16 } }
    },

    energyIcon: {
        width: 68,
        height: 86,
        offset: {
            y: 0
        }
    },

    text: {
        position: { x: { align: "center" }, y: { align: "center", dy: -24 } }
    },

    attention: {
        scale: 1,
        position: { x: { align: "center", dx: 50 }, y: { align: "center", dy: 44 } }
    }
};
